export default __webpack_public_path__ + "static/media/milla.d08ed380.jpg";